// 設定 → 安全性 → 公司帳號連結（plan SPEC #vms-web-sso-ui「我的帳號 › 安全性」）：連到的組織 / IdP、〔解除〕（要用自己的密碼 / passkey 重新驗證）。
// 沒有連結就不顯示這一區。
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useConfirm } from '../../components/ConfirmDialog';
import { ssoLinks, ssoUnlink } from '../../lib/session';
import { dateStamp } from '../../lib/timefmt';

export function SsoLinksSection() {
  const { t } = useTranslation();
  const { ask, dialog } = useConfirm();
  const qc = useQueryClient();
  const q = useQuery({ queryKey: ['sso-links'], queryFn: () => ssoLinks() });
  const del = useMutation({ mutationFn: (idp: string) => ssoUnlink(idp), onSuccess: () => void qc.invalidateQueries({ queryKey: ['sso-links'] }) });
  const links = q.data ?? [];
  if (!links.length) return null;
  return (
    <section className="card" data-testid="sso-links">
      <h2 className="section-title">{t('ssolink.title')}</h2>
      <p className="muted small">{t('ssolink.hint')}</p>
      <ul className="plain-list">
        {links.map((l) => (
          <li key={l.idp_id} className="row-inline">
            <strong>{l.org_display_name}</strong>
            <span className="small muted">
              {l.idp_display_name} · {dateStamp(l.linked_at)}
            </span>
            <button
              className="btn btn-small"
              disabled={del.isPending}
              onClick={async () => {
                if (await ask({ title: t('ssolink.unlink_title', { org: l.org_display_name }), body: t('ssolink.unlink_body'), action: t('ssolink.unlink'), danger: true })) del.mutate(l.idp_id);
              }}
            >
              {t('ssolink.unlink')}
            </button>
          </li>
        ))}
      </ul>
      {del.isError && <p className="error small">{t('ssolink.unlink_failed')}</p>}
      {dialog}
    </section>
  );
}
